import styled from 'styled-components';

export const StyledDrawerError = styled.p(
  ({ theme: { border, spacing, font, colors } }) => ({
    background: colors.errorHighlight,
    borderRadius: border.radius.sm,
    color: colors.error,
    display: 'block',
    fontSize: font.size.sm,
    fontWeight: font.weight.normal,
    lineHeight: font.lineHeight.sm,
    margin: `0 ${spacing.md}`,
    padding: spacing.sm,
    width: `calc(100% - ${spacing.md} - ${spacing.md})`,
  }),
);
